export const formatPhoneNumber = ({
  phoneNumber,
  splitSign,
}: {
  phoneNumber: string;
  splitSign?: string;
}) => {
  return phoneNumber.split('-').join(splitSign || ' ');
};
